import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Vat\LookupCompanyByVatController::__invoke
* @see app/Http/Controllers/Vat/LookupCompanyByVatController.php
* @route '/api/vat/company'
*/
const LookupCompanyByVatController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: LookupCompanyByVatController.url(options),
    method: 'get',
})

LookupCompanyByVatController.definition = {
    methods: ["get","head"],
    url: '/api/vat/company',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Vat\LookupCompanyByVatController::__invoke
* @see app/Http/Controllers/Vat/LookupCompanyByVatController.php
* @route '/api/vat/company'
*/
LookupCompanyByVatController.url = (options?: RouteQueryOptions) => {
    return LookupCompanyByVatController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Vat\LookupCompanyByVatController::__invoke
* @see app/Http/Controllers/Vat/LookupCompanyByVatController.php
* @route '/api/vat/company'
*/
LookupCompanyByVatController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: LookupCompanyByVatController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Vat\LookupCompanyByVatController::__invoke
* @see app/Http/Controllers/Vat/LookupCompanyByVatController.php
* @route '/api/vat/company'
*/
LookupCompanyByVatController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: LookupCompanyByVatController.url(options),
    method: 'head',
})

export default LookupCompanyByVatController